
class SettingBase {
	$onInit(){
		if(this.$state.current.name === `${this.id}`){
			if (this.id == 'delivery-region-routing') {
				this.$state.go(`${this.id}.create`)
			} else this.$state.go(`${this.id}.all`,{page:1})
		}		
	}
	
goToAll(){
   this.$state.go(this.id+'.all', ({
      page: 1
    }))
}	
}

export default SettingBase;


// WEBPACK FOOTER //
// ./client/app/components/settings/util/SettingBase.js